import Vue from 'vue'
import Router from 'vue-router'
import Index from 'page/Index'
import Login from 'page/Login'
import RoleManage from 'page/manage/RoleManage'
import AdminManage from 'page/manage/AdminManage'
import MenuManage from 'page/manage/MenuManage'
import ApiManage from 'page/manage/ApiManage'
import DataSourceManage from 'page/datasource/DataSourceManage'
import ModelManage from 'page/model/ModelManage'
import DictionaryManage from 'page/dictionary/DictionaryManage'
import CgProjectManage from 'page/system/CgProjectManage'
import CgSystemManage from 'page/system/CgSystemManage'
import CgUiManage from 'page/system/CgUiManage'
import IconManage from 'page/system/IconManage'
import PageManage from 'page/page/PageManage'
import FormManage from 'page/page/FormManage'
import ComponentManage from 'page/page/ComponentManage'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: Index },
    { path: '/login', component: Login },
    { path: '/manage/role-manage', component: RoleManage },
    { path: '/manage/admin-manage', component: AdminManage },
    { path: '/manage/menu-manage', component: MenuManage },
    { path: '/manage/api-manage', component: ApiManage },
    { path: '/data/data-source-manage', component: DataSourceManage },
    { path: '/data/model-manage', component: ModelManage },
    { path: '/data/dictionary-manage', component: DictionaryManage },
    { path: '/system/cg-project-manage', component: CgProjectManage },
    { path: '/system/cg-system-manage', component: CgSystemManage },
    { path: '/system/cg-ui-manage', component: CgUiManage },
    { path: '/system/icon-manage', component: IconManage },
    { path: '/page/page-manage', component: PageManage },
    { path: '/page/form-manage', component: FormManage },
    { path: '/page/component-manage', component: ComponentManage }
  ]
})
